import { createAction, props } from '@ngrx/store';
import { AlertIcon } from './alerts.reducer';

export const showAlert = createAction(
  '[Alerts] Show Alert',
  props<{ icon: AlertIcon; title: string; text: string }>(),
);
